
<!--Page 1 - Introduction-->

<template>
  <div class="page4 animated fadeIn" v-if="items">
    <div class="text">
      <h3 class="title animated fadeIn">{{items.intro.title}}</h3>
      <p v-html="items.intro.text" class="animated fadeIn"></p>
    </div>
    <img src="media/page4/transportMontage.png"/>
  </div>
</template>

<script>

export default {
  data() {
    return {

    };
  },

  computed: {
    location() {
      return this.$store.state.scormLMS.location
    },
    items() {
      return this.$store.state.items
    }
  },

  methods: {
    checkCue() {
      //BOILERPLATE FOR RUNNING AN INTERVAL
      // var self = this
      // if(Math.floor(self.$refs.audio1.currentTime) == 3){
      //   self.vis1 = "visible"
      // }
    },
    runInterval() {
      //BOILERPLATE FOR RUNNING AN INTERVAL
      this.interval = setInterval(this.checkCue, 100);
    }
  },
  mounted() {
    //JIRA POSITIONING
    this.$store.commit("scormLMS/changeUserLocation", "MA KPIs: Page 4");

    setTimeout(() => {

    }, 50);

  },
  beforeDestroy() {
    //BOILERPLATE FOR RUNNING AN INTERVAL
    clearInterval(this.interval);
  },
  components: {},
  props: []
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Page4.vue?fdf41c8e